import React, {Component} from "react";
import {Button, Modal, Layout, Table, Icon, Input} from "antd";
import _ from "i18n";
import {connect} from "react-redux";
import {getUnpaidInvoicesDetails, getDocumentsToBeExportedZipEfff, startCommandExportEfffZip, getCommandInfo} from "../../../actions/thunks.js";
import {setFiltredDocumentsToBeExportedEfffZip} from "../../../actions/actions.js";
import {formatAmount} from "utils";
import {map, reduce} from 'lodash';
import moment from "moment";
import {Link} from "react-router";
import {FileZipOutlined} from '@ant-design/icons';
import SidePageStatisticHeader from "../../common/SidePageStatisticHeader";
import SidePageHeaderPopPup from "../../common/SidePageHeaderPopUp";
import {formatPhoneNumber} from "../../../services/utils";

const { Search } = Input;

class DocumentsToBeExportedEfffZipDetails extends Component {

  constructor(props) {
    super(props);

    this.state = {
      search: '',
      showSpinner : false,
    };

    this.columns = [
      {
        title: _("credit-note-number"),
        dataIndex: "officialNumber",
        align: "left",
        width:91
      },
      {
        title: _("Date"),
        dataIndex: "documentDate",
        align: "left",
        width:74,
        render: date => moment(date).format("DD/MM/YYYY")
      },

      {
        title: _("vcs"),
        dataIndex: "vcs",
        align: "left",
        width:101,

      },


      {
        title: _("user-email"),
        align: "left",
        dataIndex: "user.mainEmail",
        width:235,

      },

      {
        title: _("user-phone"),
        align: "left",
        dataIndex: "user.mainPhone",
        width:105,
        render: phone => formatPhoneNumber(phone)

      },

      {
        title: _("organization"),
        dataIndex: "clientOrganization",
        align: "left",
        width:125,

      },


      {
        title: _("comment"),
        dataIndex: "comment",
        align: "left",
        width:259,

      },


      {
        title: _("To"),
        align: "center",
        dataIndex: "issuer.abbreviation",
        width:81,

      },


      {
        title: _("amount"),
        dataIndex: "includingVatAmount",
        align: "center",
        width:56,

        render: amount => formatAmount(amount)
      },

      {
        title: _("Status"),
        align: "center",
        dataIndex: "status",
        width:45,
        render: (text, record) => _(record.status)

      },

    ];
  }

  componentDidMount() {
    if(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0) {
      this.props.getDocumentsToBeExportedZipEfff(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0 ? this.props.statisticsFilter.apps : [] , this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length > 0 ? this.props.statisticsFilter.appRefs : [], this.props.auth.currentClient ? this.props.auth.currentClient.id : null, this.props.statisticsFilter.year && this.props.statisticsFilter.year.length > 0 ? this.props.statisticsFilter.year : [], this.props.discriminant ? this.props.discriminant : null, this.props.statisticsFilter.appType && this.props.statisticsFilter.appType.length > 0 ? this.props.statisticsFilter.appType : [])
    }
  }


  componentDidUpdate(prevProps, prevState)
  {
    if(prevProps.discriminant !== this.props.discriminant && this.props.operationType !== null) {
      this.props.getDocumentsToBeExportedZipEfff(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0 ? this.props.statisticsFilter.apps : [] , this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length > 0 ? this.props.statisticsFilter.appRefs : [], this.props.auth.currentClient ? this.props.auth.currentClient.id : null, this.props.statisticsFilter.year && this.props.statisticsFilter.year.length > 0 ? this.props.statisticsFilter.year : [], this.props.discriminant, this.props.statisticsFilter.appType && this.props.statisticsFilter.appType.length > 0 ? this.props.statisticsFilter.appType : [])
    }
  }

  calculSum = () => {
    return (this.props.documentsToBeExportedEfffZip.filteredItems).reduce((sum, { includingVatAmount , manual }) => {
        sum += parseInt(includingVatAmount);
        if (manual && manual.amount) {
          sum -= parseInt(manual.amount);
        }
        return sum
      }, 0
    )
  }


  handleSearch = (value) => {
    let {documentsToBeExportedEfffZip} = this.props;
    this.setState({search: value});
    let results=documentsToBeExportedEfffZip.items.filter((elem)=>{

      return (this.contains(elem.user.mainEmail,value.trim()) || this.contains(elem.vcs,value.trim()) || this.contains(elem.clientOrganization,value.trim()) || this.contains(elem.comment,value.trim()))
    });
    this.props.setFiltredDocumentsToBeExportedEfffZip(results);

  };

  contains(name, text) {
    if(name === null ) return;
    return (name.trim()).search(new RegExp(text, 'gi')) !== -1 || (name.trim()).search(new RegExp(text, 'gi')) === 0;
  }

  getEfffZip = () => {
    const popup = window.open(
      "",
      "_self",
    );
    this.setState({ showSpinner : true });
    this.props.startCommandExportEfffZip(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0 ? this.props.statisticsFilter.apps : [] , this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length > 0 ? this.props.statisticsFilter.appRefs : [], this.props.auth.currentClient ? this.props.auth.currentClient.id : null, this.props.statisticsFilter.year && this.props.statisticsFilter.year.length > 0 ? this.props.statisticsFilter.year : [], this.props.discriminant ? this.props.discriminant : null, "efff").then((res) => {
      // Clear previous timer
      // Clear previous timer
      clearInterval(this.commandTimer);

      const startCommandTimer = () => {
        // Pour éviter des requête concurrentes
        this.currRequestId = `COMMAND_REQUEST_${performance.now()}`;
        let prevRequestId = this.currRequestId;

        this.props.getCommandInfo(res.value.data.data.command.id)
          .then((resultat) => {
            if (prevRequestId !== this.currRequestId) {
              return;
            }

            if (resultat.data.data.status !== "FINISHED") {
              this.setState({ showSpinner : true });
              return;
            }

            // Arréter le timer
            clearInterval(this.commandTimer);
            this.setState({showSpinner : false});
            popup.location.href = resultat.data.data.result;

          })
          .catch(() => {
            clearInterval(this.commandTimer);
          });
      }

      this.commandTimer = setInterval(startCommandTimer, 3 * 1000);
    })
  }

  getPdfZip = () => {

    const popup = window.open(
      "",
      "_self",
    );
    this.setState({ showSpinner : true });
    this.props.startCommandExportEfffZip(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0 ? this.props.statisticsFilter.apps : [] , this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length > 0 ? this.props.statisticsFilter.appRefs : [], this.props.auth.currentClient ? this.props.auth.currentClient.id : null, this.props.statisticsFilter.year && this.props.statisticsFilter.year.length > 0 ? this.props.statisticsFilter.year : [], this.props.discriminant ? this.props.discriminant : null, "pdf", this.props.statisticsFilter.appType && this.props.statisticsFilter.appType.length > 0 ? this.props.statisticsFilter.appType[0] : []).then((res) => {
      // Clear previous timer
      // Clear previous timer
      clearInterval(this.commandTimer);

      const startCommandTimer = () => {
        // Pour éviter des requête concurrentes
        this.currRequestId = `COMMAND_REQUEST_${performance.now()}`;
        let prevRequestId = this.currRequestId;

        this.props.getCommandInfo(res.value.data.data.command.id)
          .then((resultat) => {
            if (prevRequestId !== this.currRequestId) {
              return;
            }

            if (resultat.data.data.status !== "FINISHED") {
              this.setState({ showSpinner : true });
              return;
            }

            // Arréter le timer
            clearInterval(this.commandTimer);
            this.setState({showSpinner : false});
            popup.location.href = resultat.data.data.result;

          })
          .catch(() => {
            clearInterval(this.commandTimer);
          });
      }

      this.commandTimer = setInterval(startCommandTimer, 3 * 1000);
    })
  }
  render() {

    const  organization = this.props.auth.currentClient ? (this.props.auth.currentClient.abbreviation ? this.props.auth.currentClient.abbreviation : this.props.auth.currentClient.name) : "";

    let {documentsToBeExportedEfffZip} = this.props
    return (
      <div className="stats-invoice-detail ">

        <div className="bg-blue-lightest h-16 modal-header-title">
          <SidePageHeaderPopPup subHeader={_("stats")}  organization = {organization}  appRefs = {this.props.statisticsFilter.appRefs} appRefsStore = {this.props.appRef}/>
        </div>

        <div className="flex flex-row justify-between mt-8" >

          <div className="flex items-center justify-start">
            <div className="recap-day-title">
              {this.props.textPopup}

            </div>

            <div className="ml-2" onClick={this.getEfffZip} style={{cursor: 'pointer'}}>
              <FileZipOutlined style={{ fontSize: '20px', color: '#2495e1' }} />
            </div>
            <div className="ml-2" style={{cursor: 'pointer'}} onClick={this.getPdfZip}>
              <Icon type="file-pdf" style={{ fontSize: '20px', color: '#2495e1' }} />
            </div>

          </div>
          <div className="w-1/3">
            <Search
              placeholder="input search text"
              onChange={({target: {value}}) => this.handleSearch(value)}
              size={"small"}
              allowClear={true}
              value={this.state.search.trim()}
            />

          </div>
        </div>

        <div className="pt-4  pb-8 relative">

          <Table
            rowKey="id"
            columns={this.columns}
            dataSource={documentsToBeExportedEfffZip.filteredItems.length > 0 ? documentsToBeExportedEfffZip.filteredItems : null}
            loading={documentsToBeExportedEfffZip.fetching}
            pagination={false}
            size="middle"
            className="ttp-invoice-detail-tab table-padding"
            scroll={{ x:false, y: 400 }}
          />

          {this.state.showSpinner ? <div className="div-fetching-file flex items-center justify-center ">

            <Icon type="sync" spin style={{ fontSize: '50px'}} />

          </div> : null
          }

        </div>

        <div className="flex flex-row justify-between pt-4  self-end pb-8">
          <div className="pr-4 border-right-line"> TOTAL</div>
          <div className="div-recap-amount-total"> { formatAmount(this.calculSum()) } </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  statisticsFilter: state.filters.statisticsFilter,
  documentsToBeExportedEfffZip: state.documentsToBeExportedEfffZip,
  auth: state.auth,
  appRef: state.appRefFilter.items,

});

const mapDispatchToProps = {
  getUnpaidInvoicesDetails,
  setFiltredDocumentsToBeExportedEfffZip,
  getDocumentsToBeExportedZipEfff,
  startCommandExportEfffZip,
  getCommandInfo
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentsToBeExportedEfffZipDetails);



// WEBPACK FOOTER //
// ./app/components/Admin/statisctics/DocumentsToBeExportedEfffZipDetails.js